module.exports = __webpack_public_path__ + "img/aidtools_10.1605a90a.png";